// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"c161b4e8","142":"ca2f5578","299":"a6c9e3f6","453":"bde4c193","515":"5daa5fdd","607":"1bdc29de","611":"4f1a3f2a","847":"6f668641","963":"df6af80e"}[chunkId] + ".chunk.js";
};